import React from 'react'
// libs
import styled from 'styled-components'
// components
import SkeftoLoader from './SkeftoLoader'

const Wrapper = styled.div<{ height: string }>`
  align-items: center;
  display: flex;
  height: ${({ height }) => height};
  justify-content: center;
  width: 100%;
`

const LoaderWithOverlay = ({ isLoading, height = '100vh' }) => {
  if (!isLoading) return null

  return (
    <Wrapper height={height}>
      <SkeftoLoader />
    </Wrapper>
  )
}

export default LoaderWithOverlay
